import * as React from "react";

const SvgIcnNewTask = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 18" {...props}>
        <path
            d="M12.5 17a.5.5 0 110 1H.5a.5.5 0 110-1h12zm3-3a.5.5 0 110 1h-9a.5.5 0 110-1h9zM9.396 3.103l2.5 2.5L2.72 14.78a.75.75 0 01-.53.22H.75a.75.75 0 01-.75-.75v-1.44a.75.75 0 01.22-.53l9.176-9.177zM12.53 1.03l1.44 1.44a.75.75 0 010 1.06l-1.367 1.366-2.5-2.5L11.47 1.03a.75.75 0 011.06 0z"
            fill="currentColor"
            stroke="none"
            strokeWidth={1}
            fillRule="evenodd"
        />
    </svg>
);

export default SvgIcnNewTask;
